export const getChartData =
  (state) =>
  (datasetName, isPercentage = false) => {
    const data = state[datasetName]?.data;
    if (!Array.isArray(data) || data.length === 0)
      return { labels: [], datasets: [] };

    const labels = Object.keys(data[0]).filter(
      (key) => key !== "Usuario" && key !== "color"
    );

    const datasets = data.map((item) => {
      const label = item.Usuario;
      const values = labels.map((key) => item[key]);
      const color = item.color || "#ccc";

      return {
        label,
        data: values,
        backgroundColor: color,
        borderColor: color,
        isPercentage, // 👉 se pasa desde el componente
      };
    });

    return { labels, datasets };
  };

export const getGroupChartData =
  (state) =>
  (datasetName, isPercentage = false) => {
    const data = state[datasetName]?.data?.group_by_data;
    const colors = state.metricColors || {};

    if (!Array.isArray(data) || data.length === 0)
      return { labels: [], datasets: [] };

    const labels = data.map((item) => item.Label);
    const metricKeys = Object.keys(data[0]).filter((key) => key !== "Label");

    const datasets = metricKeys.map((metric) => ({
      label: metric,
      data: data.map((item) => item[metric]),
      backgroundColor: colors[metric] || "#ccc",
      borderColor: colors[metric] || "#ccc",
      fill: false,
      isPercentage, // 👉 se pasa desde el componente
    }));

    return { labels, datasets };
  };

export const getGroupByTableData = (state) => (datasetName) => {
  const data = state[datasetName]?.data?.group_by_data;
  const colors = state.metricColors || {};

  if (!Array.isArray(data) || data.length === 0) return [];

  const metricas = Object.keys(data[0]).filter((key) => key !== "Label");

  const filas = metricas.map((metrica) => {
    const fila = {
      Metrica: metrica,
      color: colors[metrica] || "#ccc",
    };

    data.forEach((item) => {
      const valor = item[metrica] ?? 0;
      fila[item.Label] = `${valor}%`; // 🎯 Mostrar como string con porcentaje
    });

    return fila;
  });

  return filas;
};

export const getLabels = (state) => (datasetName) => {
  const data = state[datasetName]?.data?.group_by_data;
  return ["color", "Metrica", ...data.map((element) => element.Label)];
};
export const getUsers = (state) => {
  console.log('LLAMADO EL GETTER USERS')
  if (state.users_pbx.data) {
    const baseUrl = process.env.VUE_APP_BASE_API;
    return state.users_pbx.data.users.map((element) => {
      return {
        ...element,
        name: `${element.first_name} ${element.last_name}`,
        avatar: element.avatar ? `${baseUrl}${element.avatar}` : null,
      };
    });
  }
  return [];
};
export const getProcessedFunnelData = (state) => {
  // Verificamos si existe la data y tiene la estructura esperada
  if (!state.funnel?.data || state.funnel.data.length === 0) return null;

  // Objeto para almacenar datos procesados por semana
  const processedData = {};

  // Paleta de colores consistente
  const colorPalette = [
    "rgba(75, 192, 192, 0.7)", // verde
    "rgba(54, 162, 235, 0.7)", // azul
    "rgba(255, 99, 132, 0.7)", // rojo
    "rgba(255, 159, 64, 0.7)", // naranja
    "rgba(153, 102, 255, 0.7)", // morado
    "rgba(201, 203, 207, 0.7)", // gris
  ];

  // Procesamos cada semana
  state.funnel.data.forEach((semana) => {
    // Separar las claves en acumulados y porcentajes
    const acumKeys = Object.keys(semana.data[0] || {}).filter((key) =>
      key.startsWith("Acum.")
    );

    const percentKeys = Object.keys(semana.data[0] || {}).filter((key) =>
      key.startsWith("%")
    );

    // Función para crear datasets
    const createDatasets = (keys) => {
      return keys.map((key, index) => ({
        label: key,
        data: semana.data.map((item) => item[key]),
        backgroundColor: colorPalette[index % colorPalette.length],
        barThickness: 12,
        borderRadius: 4,
      }));
    };

    // Almacenamos los datos procesados por semana
    processedData[semana.periodo] = {
      acumulados: {
        labels: semana.data.map((item) => item.Usuario),
        datasets: createDatasets(acumKeys),
        periodo: semana.periodo,
      },
      porcentajes: {
        labels: semana.data.map((item) => item.Usuario),
        datasets: createDatasets(percentKeys),
        periodo: semana.periodo,
      },
    };
  });

  return processedData;
};
